"use client";

import { FC, memo } from "react";
import {
  Color,
  colorClassMap,
} from "apps/website/components/base/Text/Text.map";
import cx from "apps/website/utils/misc/cx";

import * as IconMap from "./Icon.map";

export interface IIcon {
  size?: IconMap.Size;
  color?: Color;
  icon: IconMap.IconSvg;
  className?: string;
  ariaHidden?: boolean
  scale?: boolean
}

const Icon: FC<IIcon> = ({
  size = "default",
  color = "default",
  icon,
  className,
  ariaHidden = false,
  scale = false,
}) => {
  const sizeClass = scale ? IconMap.iconScaledSizeClassMap[size] : IconMap.iconSizeClassMap[size];
  const computedClasses = cx(sizeClass, colorClassMap[color], className);
  const IconComponent = IconMap.iconSvgMap[icon];
  return (
    <div data-component={"Icon"} className={computedClasses} aria-hidden={ariaHidden}>
      { /** @ts-ignore */ }
      <IconComponent />
    </div>
  );
};

export default memo(Icon);
